export const APP_NAMESPACE = 'app';

// mutations
export const SET_UM_URL = 'setUserManagerUrl';
export const SET_CLIENT_ID = 'setClientId';
export const SET_API_VERSION = 'setApiVersion';

// actions
export const GET_APP_SETTINGS = 'getAppSettings';

export default {};
